import { Locale, format, parseISO } from 'date-fns';

type FormateDateProps = {
    dateString: string;
    locale: string;
    supportedLocales: ({ lang }: {
        lang: string;
    }) => Locale;
};

function capitalizeFirstLetter(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function formatDate({ dateString, locale, supportedLocales }: FormateDateProps): string {
  const date = parseISO(dateString);
  const dateFormat = locale === 'en-US' ? 'EEEE, MMMM dd \'of\' yyyy' : 'EEEE, dd \'de\' MMMM \'de\' yyyy';

  let formattedDate = format(date, dateFormat, {
    locale : supportedLocales({ lang : locale })
  });

  formattedDate = capitalizeFirstLetter(formattedDate);

  const hours = date.getHours();
  const minutes = date.getMinutes();
  const timezoneOffset = -date.getTimezoneOffset() / 60;
  const timezone = `UTC${timezoneOffset >= 0 ? '+' : ''}${timezoneOffset}`;

  const formattedTime = `${hours}h${minutes.toString().padStart(2, '0')}`;

  return `${formattedDate} - ${formattedTime} ${timezone}`;
}

export default formatDate;
